import {
  Columns2,
  MapPin,
  Wallet,
  SlidersHorizontal,
  Percent,
  Clock,
  CalendarClock,
  UserRound,
  Timer,
  Zap,
  ListOrdered,
  Trophy,
} from "lucide-react";

/* Salary (Hospital) calculator tour content, ported from the mobile
   "Calculator" mockup's hospital-view steps, plus a state-filter step for
   the real page's title-aligned state dropdown (the mockup had none). The
   generic GuidedTour engine renders these; this is just the data. Only the
   salary view — the paycheck tab has no tour. */
export default function getSalariesTourSteps() {
  return [
    {
      cardSelector: '[data-tour="salary-tabs"]',
      targetSelector: '[data-tour="salary-tabs"]',
      icon: <Columns2 />,
      title: "Two calculators",
      text: "Switch between Hospital union rates and a full Paycheck breakdown.",
    },
    {
      cardSelector: '[data-tour="salary-state"]',
      targetSelector: '[data-tour="salary-state"]',
      icon: <MapPin />,
      title: "Filter by state",
      text: "Narrow the hospital rankings to a single state — or keep All States.",
    },
    {
      cardSelector: '[data-tour="salary-hero"]',
      targetSelector: '[data-tour="salary-hero"]',
      icon: <Wallet />,
      title: "Top hospital",
      text: "The highest-paying hospital in the ranking — estimated pay, before housing.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-inputs"]',
      icon: <SlidersHorizontal />,
      title: "Your inputs",
      text: "The assumptions used to estimate pay — adjust them to personalize the numbers.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-rate_per"]',
      icon: <Percent />,
      title: "Rate per",
      text: "View rates as annual, hourly, weekly, bi-weekly, or monthly.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-hours_per_week"]',
      icon: <Clock />,
      title: "Hours per week",
      text: "Your scheduled weekly hours.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-years_of_experience"]',
      icon: <CalendarClock />,
      title: "Years of experience",
      text: "Union step pay rises with seniority.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-position"]',
      icon: <UserRound />,
      title: "Position",
      text: "Bargaining unit and role — a Pro input.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-over_time"]',
      icon: <Timer />,
      title: "Overtime hours",
      text: "Add weekly overtime — a Pro input.",
    },
    {
      cardSelector: '[data-tour="salary-inputs"]',
      targetSelector: '[data-tour="salary-field-double_time"]',
      icon: <Zap />,
      title: "Double-time hours",
      text: "Add double-time hours — a Pro input.",
    },
    {
      cardSelector: '[data-tour="salary-rankings"]',
      targetSelector: '[data-tour="salary-rankings"]',
      icon: <ListOrdered />,
      title: "Hospital salary rankings",
      text: "Every hospital ranked by pay. The top one is free; the rest unlock with Pro.",
    },
    {
      cardSelector: '[data-tour="salary-summary"]',
      targetSelector: '[data-tour="salary-summary"]',
      icon: <Trophy />,
      title: "Salary summary",
      text: "A summary for the #1 hospital — highest salary and a net-pay estimate.",
    },
  ];
}
